<script lang="ts">
    import { onMount } from 'svelte';
    import PageHeader from '../components/PageHeader.svelte';
    import { getPartners } from "../scripts/apiEcosystems";
    import { storePartners, storeEcosystemsError } from "../scripts/ecosystem";
    import { addNotificationError }  from "../scripts/toaster";
    import { storeLanguage, lang_fr, storeLoader } from "../scripts/store";
    import { launchLoader, stopLoader } from "../scripts/utils";
    import HomePartenaires from '../components/HomePartenaires.svelte';

    onMount(async () => {
        getPartnersIfEmpty();
        window.scrollTo(0,0);
	});

    /**
     * getPartnersIfEmpty
     */
    function getPartnersIfEmpty() {
        if ($storePartners.length <= 0) {
            launchLoader();
            const loadEcosystem = getPartners();
            loadEcosystem.then((data) => {
                stopLoader();
                if (!data) {
                    addNotificationError($storeEcosystemsError);
                };
            });
        }
    }

</script>
    
<style lang="scss">

    .nospartenaires {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: center;
        width: 100%;
        &__bloc {
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            align-items: center;
        }
        &__tiles {
            display: flex;
            flex-direction: row;
            justify-content: space-around;
            flex-wrap: wrap;
            align-items: center;
            margin: 0 32px 0 32px;
        }
    }

    @include large {
        .nospartenaires {
            &__tiles {
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;
                flex-wrap: wrap;
            }
        }
    }

</style>

<div class="nospartenaires">
    {#if ($storeLanguage == $lang_fr)}
    <PageHeader props="nos partenaires"/>
    {:else}
    <PageHeader props="our partners"/>
    {/if}
    <HomePartenaires />
</div>
